import { SegmentedControl } from '../../Common/_components';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Selectors } from '../../Everou/_reducers/app.reducer';
import { SyncStatusValue } from '../../Everou/_modelsTS/Integration';
import { PMSLocationDetailViewModes } from '../_constants/pmsLocationsViewMode.constants';
import { viewModeNames } from '../_constants/pmsLocationsViewMode.constants';
import { viewModeActions } from '../_actions/viewMode.actions';
import { VACATION_RENTAL_PLANS } from '../_constants/vacationRentalPlan.constants';


export function PMSLocationDetailSelector() {
    
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const viewMode = useSelector(Selectors.getPMSLocationDetailViewMode);
    // The plan is already known from the locations list when the location is
    // selected, so the Premium-only tabs render right away instead of popping
    // in once location/info resolves. Falling back to locationInfo would show
    // the PREVIOUS location's tabs during that window, so the list value wins
    // and locationInfo is only the fallback (same seeding trick as the
    // has_integration flag in PMSLocationDetail).
    const selectedVacationRentalPlan = useSelector(Selectors.getPMSLocationSelectedVacationRentalPlan);
    const locationInfo = useSelector(Selectors.getPMSLocationInfo);
    const vacationRentalPlan = selectedVacationRentalPlan ?? locationInfo?.vacationRentalPlan;
    const selectedHasIntegrationError = useSelector(Selectors.getPMSLocationSelectedHasIntegrationError);
    const locationIntegrations = useSelector(Selectors.getPMSLocationIntegrations);

    // Prefer the live state of the already-loaded integrations (so the flag
    // clears/sets right after a sync or a credentials fix) and fall back to the
    // backend-computed flag from the locations list when they aren't loaded yet
    // (the tab must warn even before it's opened).
    const hasIntegrationError = locationIntegrations?.length
        ? locationIntegrations.some(
              ({ syncStatus, apikeyIsValid }) =>
                  syncStatus === SyncStatusValue.ERROR || apikeyIsValid === false,
          )
        : selectedHasIntegrationError;

    return (
        <div className="d-flex">
            <SegmentedControl
                preventDefaultSelect
                defaultSelected={{
                    value: viewMode
                }}
                onSelect={handleChangeViewMode}
                segments={segments()}
            />
        </div>
    );

    function segments() {
        return Object.keys(PMSLocationDetailViewModes)
            .filter(isViewModeAvailable)
            .map((viewMode) => ({
                label: segmentLabel(viewMode),
                value: viewMode,
            }));
    }

    function segmentLabel(mode) {
        const name = viewModeNames[mode];
        // Flag the Integrations tab when any of the location's integrations is
        // in error, so it's visible without opening the tab.
        if (mode === PMSLocationDetailViewModes.INTEGRATIONS && hasIntegrationError) {
            return (
                <span>
                    {name} <span role="img" aria-label="warning">⚠️</span>
                </span>
            );
        }
        return name;
    }

    function isViewModeAvailable(mode) {
        if (
            mode === PMSLocationDetailViewModes.PUBLIC_LINK_DEVICES ||
            mode === PMSLocationDetailViewModes.AUDIT ||
            mode === PMSLocationDetailViewModes.ALARM ||
            mode === PMSLocationDetailViewModes.INVITATIONS
        ) {
            return vacationRentalPlan === VACATION_RENTAL_PLANS.PREMIUM_PLAN;
        }
        return true;
    }

    function handleChangeViewMode(viewMode) {
        dispatch(viewModeActions.changeMode(viewMode));
    }
}